export const YOUTUBE_URL = "https://youtube.com/@creativeknackshub?si=CUNFCy4xUGI5Poae";
export const INSTAGRAM_URL = "https://www.instagram.com/creative_knacks?igsh=NDFxMXB0NGprZXU5";
export const BEHANCE_URL ="https://www.behance.net/creativeknacks";
export const LINKEDIN_URL = "";
export const FACEBOOK_URL = "";
export const X_URL = "";

export const COMPANY_EMAIL = "kishoreml2909@gmail.com";